/** Shared cursor pagination options for infinite queries. */

type Cursor = string | undefined
export const pageOpts = {
  initialPageParam: undefined as Cursor,
  getNextPageParam: (last: { nextCursor: string | null }) => last.nextCursor ?? undefined,
}
